import UIDivNode from './UIDivNode';

export default class UIRootNode extends UIDivNode {}
